import { validateFirstStep } from "utils"

/**
 * Validation functions for each section
 * Returns an object with validation errors or empty object if valid
 */

export const validateListingSection = (formData, showAdditionalInputs) => {
    const objectToValidate = {
        profile_pic: formData.profile_pic,
        subject_want_to_teach: formData.subject_want_to_teach,
        subject_sub_category: formData.subject_sub_category,
        zip_code: formData.zip_code,
        city: formData.city,
        state: formData.state,
        experience_on_subject: formData.experience_on_subject,
        level_of_student: formData.level_of_student,
        student_need_to_have: formData.student_need_to_have,
        expected_students: formData.expected_students,
    }

    if (formData?.online_type === "offline") {
        objectToValidate.neighborhood = formData.neighborhood
    }

    if (formData.online_type !== "offline") {
        objectToValidate.price_per_online_class = formData?.price_per_online_class
    }

    if (formData.online_type !== "online") {
        objectToValidate.locations_of_class = formData.locations_of_class
    }

    if (showAdditionalInputs?.whatExpectMyClassOnline) {
        objectToValidate.expected_students_online = formData.expected_students_online
    }

    if (showAdditionalInputs?.whatParticipantsTakeClass) {
        objectToValidate.student_need_to_have_online = formData.student_need_to_have_online
    }

    return validateFirstStep(objectToValidate, true)
}

export const validatePriceSection = (formData, selectedOption) => {
    const errors = {}
    const MINIMUM_CLASS_PRICE = 20
    const MAXIMUM_CLASS_PRICE = 5000

    const isGroupClass = selectedOption?.label?.includes("Group")
    const isPrivateClass = selectedOption?.label?.includes("Private")
    const isOnlineClass = selectedOption?.label?.includes("Online")

    if (isGroupClass) {
        if (!formData.price_per_group_class || formData.price_per_group_class === "") {
            errors.price_per_group_class = "Price must be filled"
        } else if (formData.price_per_group_class < MINIMUM_CLASS_PRICE) {
            errors.price_per_group_class = "Minimum price per class is $20"
        } else if (formData.price_per_group_class > MAXIMUM_CLASS_PRICE) {
            errors.price_per_group_class = "Maximum price per class is $5000"
        }

        if (!formData.number_of_students || formData.number_of_students < 1) {
            errors.number_of_students = "Minimum number of participants is 1"
        } else if (formData.number_of_students > 20) {
            errors.number_of_students = "Maximum number of participants is 20"
        }
    }

    if (isPrivateClass) {
        if (!formData.price_per_private_class || formData.price_per_private_class === "") {
            errors.price_per_private_class = "Price must be filled"
        } else if (formData.price_per_private_class < MINIMUM_CLASS_PRICE) {
            errors.price_per_private_class = "Minimum price per class is $20"
        } else if (formData.price_per_private_class > MAXIMUM_CLASS_PRICE) {
            errors.price_per_private_class = "Maximum price per class is $5000"
        }

        if (!formData.number_of_students_private_class || formData.number_of_students_private_class < 1) {
            errors.number_of_students_private_class = "Minimum number of participants is 1"
        } else if (formData.number_of_students_private_class > 20) {
            errors.number_of_students_private_class = "Maximum number of participants is 20"
        }
    }

    if (isOnlineClass) {
        if (!formData.price_per_online_class || formData.price_per_online_class === "") {
            errors.price_per_online_class = "Price must be filled"
        } else if (formData.price_per_online_class < MINIMUM_CLASS_PRICE) {
            errors.price_per_online_class = "Minimum price per class is $20"
        } else if (formData.price_per_online_class > MAXIMUM_CLASS_PRICE) {
            errors.price_per_online_class = "Maximum price per class is $5000"
        }
    }

    return errors
}

export const validatePhotosSection = (selectedImages) => {
    const errors = {}
    const undeletedImages = selectedImages?.filter((img) => !img.deleted)

    if (!undeletedImages || undeletedImages.length < 2) {
        errors.gallery = "Select at least 2 images"
    }

    return errors
}

export const validatePoliciesSection = (formData) => {
    const errors = {}

    // Policies are optional, so we just check if profile picture is uploaded
    // The actual policy validation is handled by the policy hooks in the Policies component
    if (formData.profile_pic && formData.profile_pic.uri.length === 0) {
        errors.profile_pic = "Upload profile picture first"
    }

    return errors
}

export const validateScheduleSection = (classAvailability, classDuration) => {
    const errors = {}

    if (!classDuration) {
        errors.classDuration = "Class duration must be filled"
        return errors
    }

    if (classDuration < 30) {
        errors.classDuration = "Class duration must be at least 30 minutes"
        return errors
    }

    const activatedClassAvailability = classAvailability.filter((classAv) => classAv.isActive)

    const flattenedClasses = activatedClassAvailability?.flatMap((cls) => {
        return cls.schedules
    })

    if (flattenedClasses.length < 1) {
        errors.schedule = "Add at least 1 class"
    }

    return errors
}
